export default __webpack_public_path__ + "static/soniincorporation-11eb21660139ee8b1473dccf0799ea94.png";